```vue
<template>
  <div class="right-suspension" v-if="!isMobile">
    <div
      class="fix-right"
      :class="{ 'slide-out': !isExpanded, 'slide-in': isExpanded }"
      :style="{ opacity: isExpanded || isAnimating ? 1 : 0 }"
    >
      <div class="service-item">
        <div class="icon-wrapper"
             @mouseenter="showServiceQr = true"
             @mouseleave="showServiceQr = false">
          <img :src="require('@/assets/newhome/kefu.png')" class="right-img"/>
          <div class="right-font">联系客服</div>
          <div class="service-qr-popup" v-if="showServiceQr">
            <div class="qr-content">
              <img  :src="require('@/assets/newhome/kefuerweima.jpg')" class="qr-img"/>
              <div class="qr-text">010-81791868</div>
            </div>
            <div class="qr-arrow"></div>
          </div>
        </div>
      </div>
      <div
        class="qrcode-container"
        style="text-align: center; position: relative;"
        v-if="websit.appletPath || websit.officialAccountPath"
      >
        <img
          :src="require('@/assets/newhome/erweima.png')"
          class="right-img qrcode-trigger"
          @mouseenter="showQrCode = true"
          @mouseleave="showQrCode = false"
        />
        <div class="right-font">二维码</div>
        <div
          class="qrcode-popup"
          v-if="showQrCode"
          :style="{ width: hasBothQrCodes ? '285px' : '142px' }"
        >
          <div
            v-if="websit.appletPath"
            :class="hasBothQrCodes ? 'mobile-img' : 'code-img'"
          >
            <img :src="websit.appletPath" style="width: 100px;height: 100px;"/>
            <div class="code-font">
              移动端二维码
            </div>
          </div>
          <div
            v-if="websit.officialAccountPath"
            :class="hasBothQrCodes ? 'code-img' : 'code-img'"
          >
            <img :src="websit.officialAccountPath" style="width: 100px;height: 100px;"/>
            <div class="code-font">
              公众号二维码
            </div>
          </div>
          <div class="qrcode-arrow"></div>
        </div>
      </div>
<!--      <div @click="handleService" style="text-align: center;">-->
<!--        <img :src="require('@/assets/newhome/question.png')" class="right-img"/>-->
<!--        <div class="right-font">常见问题</div>-->
<!--      </div>-->
      <div style="text-align: center;" @click="toTop">
        <img :src="require('@/assets/newhome/gotop.png')" class="right-img"/>
        <div class="right-font">返回顶部</div>
      </div>
      <div class="click-hide" @click="toggleExpand(false)">
        点击收起
        <img :src="require('@/assets/newhome/hide.png')" class="hide-img"/>
      </div>
    </div>
    <div
      class="show-fix"
      :class="{ 'slide-in-reverse': isExpanded, 'slide-out-reverse': !isExpanded }"
      :style="{
        opacity: (!isExpanded || isAnimating) ? 1 : 0,
        pointerEvents: (!isExpanded || isAnimating) ? 'auto' : 'none'
      }"
      @click="toggleExpand(true)"
    >
      <img :src="require('@/assets/newhome/show.png')" class="show-img"/>
      点击展开
    </div>
  </div>
</template>
<script>
import apis from '@/apis/home'
import { mapGetters } from 'vuex'
export default {
  name: 'right-suspension',
  data () {
    return {
      showServiceQr: false,
      isExpanded: true,
      showQrCode: false,
      isMobile: null,
      isAnimating: false,
      animationDuration: 300
    }
  },
  mounted () {
    this.ismobile()
  },
  computed: {
    ...mapGetters(['footerList', 'siteIntro', 'websit', 'columnTreeList']),
    hasBothQrCodes () {
      return this.websit && this.websit.appletPath && this.websit.officialAccountPath
    }
  },
  methods: {
    ismobile () {
      this.isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    toggleExpand (expand) {
      this.isAnimating = true
      this.isExpanded = expand
      setTimeout(() => {
        this.isAnimating = false
      }, this.animationDuration)
    },
    handleService () {
      apis.getColumnByColumnName({columnName: '帮助中心'}).then(res => {
        if (res) {
          this.$router.push({ path: '/aboutacademy', query: { columnId: res.id, activeChildrenIndex: res.id } })
        }
      })
    },
    toTop () {
      document.documentElement.scrollTop = 0
    }
  }
}
</script>
<style scoped>
.fix-right{
  background-color:#fff;
  padding: 10px 10px 0px;
  border-radius: 10px;
  position: fixed;
  top: 40%;
  right: 20px;
  z-index: 999;
  cursor: pointer;
  transform: translateZ(0);
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, opacity 0.3s ease;
  transform: translateX(0);
  opacity: 1;
}
.show-fix{
  position: fixed;
  padding: 10px 20px;
  background-color: #2A78FF;
  top: 60%;
  font-weight: bold;
  font-size: 14px;
  border-radius: 8px 0px 0px 8px;
  color: #FFFFFF;
  z-index: 999;
  cursor: pointer;
  right: 0;
  transform: translateX(100%);
  transition: transform 0.3s ease, opacity 0.3s ease;
  white-space: nowrap;
  opacity: 0;
  box-shadow: 8px 4px 2px rgba(0, 0, 0, 0.081);
}
.slide-out {
  transform: translateX(120%);
}
.slide-in {
  transform: translateX(0);
}
.slide-out-reverse {
  transform: translateX(0);
}
.slide-in-reverse {
  transform: translateX(100%);
}
.right-img{
  width: 35px;
  height: 35px;
  padding-top: 10px;
}
.hide-img{
  width: 6px;
  height: 10px;
  position: relative;
  top: 1px;
}
.show-img{
  width: 6px;
  height: 10px;
  position: relative;
  top: 0px;
  margin-right: 5px;
}
.click-hide{
  font-weight: bold;
  margin: 10px 0px 15px;
  font-size: 12px;
  text-align: center;
  color: #666666;
}
.right-font{
  font-weight: bold;
  padding-bottom: 10px;
  border-bottom: 1px solid #DCDCDC;
  font-size: 14px;
  color: #333333;
}
.qr-content {
  text-align: center;
}
.qr-img {
  width: 110px;
  height: 110px;
  display: block;
}
.qr-text {
  font-size: 13px;
  color: #333;
  font-weight: bold;
  margin-top: 3px;
}
.qr-arrow {
  position: absolute;
  right: -8px;
  top: 20px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #fff;
}
.qrcode-container {
  position: relative;
}
.qrcode-popup {
  position: absolute;
  right: 70px;
  top: 50%;
  transform: translateY(-50%);
  height: 160px;
  background-color: #fff;
  box-shadow: 0 3px 10px rgba(0,0,0,0.2);
  z-index: 1000;
}
.service-qr-popup {
  position: absolute;
  right: 70px;
  top: 20px;
  background-color: #fff;
  padding: 15px;
  box-shadow: 0 3px 15px rgba(0,0,0,0.2);
  z-index: 1000;
}
.qrcode-arrow {
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #fff;
  box-shadow: -2px 0 2px rgba(0,0,0,0.1);
}
.qrcode-trigger {
  cursor: pointer;
  transition: transform 0.2s;
}
.qrcode-trigger:hover {
  transform: scale(1.05);
}
.mobile-img{
  border-right: 1px solid #DCDCDC;
  float: left;
  margin: 20px 0px 20px 20px;
  padding-right: 20px;
}
.icon-wrapper {
  position: relative;
  cursor: pointer;
  text-align: center;
}
.code-img{
  float: left;
  margin: 20px 0px 20px 23px;
}
.code-font{
  font-weight: bold;
  font-size: 13px;
  color: #666666;
}
</style>
